import { Component, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { NavController, NavParams, LoadingController, ViewController } from 'ionic-angular';
import { Subscription }  from 'rxjs/Subscription';
import { DataProvider } from '../../providers/data/data';
import { GoogleMap, GoogleMapsEvent, Marker, GoogleMaps, GoogleMapOptions } from '@ionic-native/google-maps';

/**
 * Generated class for the ViewSelectBranchPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-view-select-branch',
  templateUrl: 'view-select-branch.html',
})
export class ViewSelectBranchPage implements OnDestroy {
  
  @ViewChild('mapakenCanvass') mapElement: ElementRef;
  map: GoogleMap = null;

  coordx: any;
  coordy: any;

  latx: any;
  laty: any;

  data: any[] = [];

  listBranches: any[] = [];

  branchesSub: Subscription;


  branchStore: string;
  branchContactNo: string;

  constructor(public navCtrl: NavController, public navParams: NavParams
  	, private loadingCtrl: LoadingController
  	, private dataProv: DataProvider
  	, private viewCtrl: ViewController
  	) {

  	this.coordx =  16.032197;
  	this.coordy = 120.330026;
  }

  ionViewDidLoad() {
    this.loadMap();
  }

  loadMap() {
  	let mapOptions: GoogleMapOptions = {
      camera: {
         target: {
           lat: this.coordx,
           lng: this.coordy
         },
         zoom: 10
       },
       mapType: 'MAP_TYPE_ROADMAP'
    };

    let element = this.mapElement.nativeElement;
  	
	this.map  = GoogleMaps.create(element, mapOptions);

  	this.map.one(GoogleMapsEvent.MAP_READY).then(() => {
  		this.loadSJD();
	},
	err => {
		alert(err);
	}).catch(err=> {
		alert(err);
	});
  }

  loadSJD() {
  	this.listBranches = [];

  	let loadingx = this.loadingCtrl.create({
  		content: 'Loading Stores',
  		enableBackdropDismiss: true
  	});

  	loadingx.present();
  	

  	this.branchesSub = this.dataProv.getBranches()
	  .subscribe((rs: any[]) => {
		
		this.listBranches = rs['data'];

		let sjdPos = this.listBranches.sort((a,b)=>b.s_latilong.localeCompare(a.s_latilong));

		let ico = {
	  		url: 'assets/imgs/sjd_pin.png',
	  		size: {
	  			width: 35,
	  			height: 40
	  		}
	  	}

	  	for(var i = 0; i < sjdPos.length; i++) {

	  		let ss: string  = sjdPos[i].s_latilong;

	  		var ss1;

  			var sillyString = ss.substr(1).slice(0, -1);	
  			ss1 = sillyString.split(',');	

	  		if(ss1.length > 0) {
	  			this.latx = ss1[0].substr(4, ss1[0].length).trim();	
				  this.laty = ss1[1].substr(5, ss1[1].length).trim();		


		  // 		let htmlInfoWindow = new HtmlInfoWindow();
				// let frame: HTMLElement = document.createElement('div');
				// frame.innerHTML = [
				//   '<div style="font-size: 15px; font-weight-bold; background-color: #026434; color: #fff; padding: 5px; width: 100%">'+ ssB.toUpperCase() +'</div><hr>',
				//   '<table style="width: 100%"><tr><td valign="top" style="background-color: lightgray; padding: 3px">Address:</td><td valign="top" style="padding: 3px;">'+ sjdPos[i].s_brncaddr +'</td>',
				//   '</tr><tr><td valign="top" style="background-color: lightgray; padding: 3px;">Schedule:</td><td valign="top" style="padding: 3px;">'+ sjdPos[i].s_schedule +'</td>',
				//   '</tr><tr><td valign="top" style="background-color: lightgray; padding: 3px">Contact No:</td><td valign="top" style="padding: 3px;">'+ sjdPos[i].s_contnmbr +'</td></tr></table><hr>'
				//   // '<hr><span>Address: '+ sjdPos[i].address +'</span><br><span>Schedule: '+ sjdPos[i].schedule +'</span><br><span>Contact No.: '+ sjdPos[i].contactno +'</span>'
				// ].join("");
				
				// htmlInfoWindow.setContent(frame, { width: "230px", height: "190px" });

		  		this.map.addMarker({
			  		title: sjdPos[i].s_brncname,
			  		snippet: sjdPos[i].s_mobileno,
			  		icon: ico,
			  		animation: 'DROP',
			  		position: {
			  			lat: this.latx,
			  			lng: this.laty,
			  		}
			  	}).then((marker: Marker) => {
			  		marker.on(GoogleMapsEvent.MARKER_CLICK).subscribe(() => {
					  	this.clickBranch(marker.getTitle().toString(), marker.getSnippet().toString());
				  		marker.showInfoWindow();

				    });

				    loadingx.dismiss();
			  	});

	  		} else { 
	  			console.log('no coordinates'); 
	  			// loading.dismiss(); 
	  		}
	  		
	  	}

	  	loadingx.dismiss();

	}, 
	error => {
		loadingx.dismiss();
		alert('Internet Connection: Please check your internet connection or too slow internet connection.');
	},
	function() {
		loadingx.dismiss();
	});
  }

  cancelForm() {
  	this.viewCtrl.dismiss();
  }

  clickBranch(info: string, contact: string) {
  	let _s1 = info;
  	let _s2 = contact;

  	this.branchStore = _s1;
  	this.branchContactNo = _s2;

  	this.data = [{ branchStore: this.branchStore, branchContactNo: this.branchContactNo }];

  }

  selectBranch() {
  	this.viewCtrl.dismiss(this.data);
  }

  ngOnDestroy() {
  	if(this.branchesSub) {
  		this.branchesSub.unsubscribe();
  	}
  }

  ionViewWillLeave() {

    const nodeList = document.querySelectorAll('._gmaps_cdv_');

    for (let k = 0; k < nodeList.length; ++k) {
        nodeList.item(k).classList.remove('_gmaps_cdv_');
    }

  }

}



// WEBPACK FOOTER //
// ./src/pages/view-select-branch/view-select-branch.ts